<div class="change-plan-container">
    <p class="change-plan">{{properties.changePlan.changePlanText}}</p>
    <div class="plan-text pt-2">
        <span class="sr-only">graphic info icon</span>
        <span aria-hidden="true">
            <img alt="info icon image" class="info-icon"
                 src="https://www-qa1.safeway.com/etc/designs/wcax-commons/images/icons/info.png">
        </span>
        <div>
            <span>{{properties.changePlan.planTextOne}}</span>
            <span><b> {{governmentAssisted}} {{nonSelectedSubscriptionType}} {{properties.changePlan.plan}} </b></span>
            <span>{{properties.changePlan.planTextTwo}}</span>
            <span aria-hidden="true"> {{currentPlanExpiryDate}} </span> 
            <span class="sr-only">{{getCurrentPlanExpiryDate(currentPlanExpiryDate)}}</span>.
        </div>
    </div>
</div>

